import { render } from "./parents.vue?vue&type=template&id=266089f9"
import script from "./parents.vue?vue&type=script&lang=js"
export * from "./parents.vue?vue&type=script&lang=js"

import "./parents.vue?vue&type=style&index=0&id=266089f9&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__